import {
  IonContent,
  IonIcon,
  IonItem, IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  useIonRouter,
  IonPopover,
  IonText,
} from '@ionic/react';
import {
  chatbubbleOutline, chatbubbleSharp, documentTextOutline, documentTextSharp, giftOutline, giftSharp, heart, homeOutline,
  homeSharp, storefrontOutline, storefrontSharp, logOutOutline, logOutSharp, journalSharp, journalOutline, newspaperOutline, newspaperSharp
} from 'ionicons/icons';
import { useState, useRef } from 'react';
import { useLocation } from 'react-router';
import { User } from '../models/data';
import { translation } from '../models/translation';
import './Menu.css';
import AuthServ from '../services/auth';


interface AppPage {
  url: string;
  iconUrl?: string;
  iosIcon?: string;
  mdIcon?: string;
  title: string;
}


interface MenuProps {
  user: User,
  lan: string
  signIn: any,
  removeUser: any,
}

const Menu: React.FC<MenuProps> = ({ user, signIn, removeUser }) => {

  const siteText = translation();
  const authServ = new AuthServ();
  const history = useIonRouter();
  const location = useLocation();

  const lanPopover = useRef<HTMLIonPopoverElement>(null);


  const handleSignOut = async () => {
    await authServ.unSetUser();
    signIn(false);
    removeUser();
    history.push(lan + '/');

  }

  const svgUrl = `${process.env.PUBLIC_URL}/assets/svg/`;

  const [lan] = useState(siteText.lan);

  const languages = [
    {
      name: 'Deutsch',
      ext: '/de'
    },
    {
      name: 'Français',
      ext: '/fr'
    },
    {
      name: 'English',
      ext: '/en'
    },

  ]

  const [lanPopoverOpen, setLanPopoverOpen] = useState(false);
  const openLanPopoverOnMobile = () => {
    //setPopoverOpen(false)
    setLanPopoverOpen(true)
  }
  const switchLan = async (e: any) => {
    let targetlan = e;
    if (targetlan === lan) {
      return;
    } else if (location.pathname.indexOf('home') > 0) {
      window.location.href = e
    } else {
      window.location.href = location.pathname.replace(lan, targetlan);
    }
  }


  const appPagesTop: AppPage[] = [
    {
      title: siteText.menuAccountHomeTxt,
      url: lan + '/account/start',
      iosIcon: homeOutline,
      mdIcon: homeSharp
    },
    {
      title: siteText.menuAccountDonateTxt,
      url: lan + '/account/donate',
      iconUrl: `${svgUrl}${'fundraise_2.svg'}`,
     
    },
    /*{
      title: siteText.menuAccountFundraiseTxt,
      url: lan + '/account/fundraise',
      iconUrl: `${svgUrl}${'fundraise_2.svg'}`

    },*/
    {
      title: siteText.giftTitle,
      url: lan + '/account/giftCard',
      iosIcon: giftOutline,
      mdIcon: giftSharp
    },
    {
      title: siteText.menuAccountCharitiesTxt,
      url: lan + '/account/charities',
      iosIcon: heart,
      mdIcon: heart
    },
    {
      title: siteText.menuAccountHistoryTxt,
      url: lan + '/account/history',
      iosIcon: documentTextOutline,
      mdIcon: documentTextSharp
    },
    {
      title: siteText.menuAccountSwNewsTxt,
      url: lan+'/articles',
      iosIcon:newspaperOutline,
      mdIcon:newspaperSharp
    },
    {
      title: siteText.menuAccountAboutTxt,
      url: lan + '/account/about',
      iosIcon: storefrontOutline,
      mdIcon: storefrontSharp
    },

  ];
  const appPagesBottom: AppPage[] = [
    /*{
      title: 'FAQ',
      url: lan + '/account/faq',
      iosIcon: chatbubbleOutline,
      mdIcon: chatbubbleSharp
    },*/



  ];


  return (
    <>
      <IonMenu contentId='main' type='overlay'>
        <IonContent>
          <IonList id="account_pages">
            <IonItem className='ion-hide-md-up' button onClick={openLanPopoverOnMobile}>{`${lan.replace("/", "").toUpperCase()}`}</IonItem>
            {appPagesTop.map((appPage, index) => {
              return (
                <IonMenuToggle key={index} autoHide={false}>
                  <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                    <IonIcon slot="start" src={appPage.iconUrl ? appPage.iconUrl : ''} ios={appPage.iosIcon} md={appPage.mdIcon} />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              );
            })}
            {appPagesBottom.map((appPage, index) => {
              return (
                <IonMenuToggle key={index} autoHide={false}>
                  <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                    <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                  <IonItem className='ion-hide-sm-up' detail={true} type="button" lines='none' onClick={handleSignOut}>
                    <IonIcon slot='start' ios={logOutOutline} md={logOutSharp}></IonIcon>
                    <IonLabel>{siteText.siteLogOutBtnTxt}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              );
            })}

          </IonList>
          {/**lan switcher desktop */}
          <IonPopover ref={lanPopover} isOpen={lanPopoverOpen} showBackdrop={false} onDidDismiss={() => { setLanPopoverOpen(false) }}>
            <IonContent className="ion-padding">
              <IonList>
                {languages.map((language, key) => {
                  return <IonItem button disabled={lan === language.ext ? true : false} key={key} onClick={() => switchLan(language.ext)} >
                    <IonText color={lan === language.ext ? 'primary' : 'dark'}>{language.name}</IonText>
                  </IonItem>
                })}
              </IonList>
            </IonContent>
          </IonPopover>
        </IonContent>
      </IonMenu>


    </>
  );
};

export default Menu;
